import { useState, useEffect, useContext } from "react";
import { useAuth } from "../../context/AuthContext";
import {
  getappointmentsPerDates,
  AddAppointment,
  AddAnyWayAppointment,
} from "../../api/appointmentApi";
import { getbarbers } from "../../api/barberApi";
import { getUnavailabilityByBarber } from "../../api/barberUnAvailabiltyApi";
import { createUnavailability } from "../../api/barberUnAvailabiltyApi";
const useCalendar = () => {
  const [view, setView] = useState("week");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [displayedAppointments, setDisplayedAppointments] = useState([]);
  const [employeeColors, setEmployeeColors] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [unavailableEmployees, setUnavailabelEmployees] = useState([]);
  const [selectedDateSlot, setSelectedDateSlot] = useState();
  const [showModal, setshowModal] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [unavailability, setUnavailability] = useState(null);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    getEmployees();
  }, []);
  useEffect(() => {
    displayAppointments();
    getUnavailableEmployees();
  }, [selectedEmployees, appointments]);
  const refresh = () => {
    getAppointments();
    getUnavailableEmployees();
  };
  const displayAppointments = () => {
    const selectedEmployeeNames = employees
      .filter((employee) => selectedEmployees.includes(employee.id))
      .map((employee) => employee.name);
    const filteredAppointments = appointments.filter((appointment) =>
      selectedEmployeeNames.includes(appointment.staffName),
    );
    setDisplayedAppointments(filteredAppointments);
  };
  useEffect(() => {
    getAppointments();
  }, [selectedDate, view]);

  useEffect(() => {
    const colors = [
      "#7C3AED", // Purple
      "#0F766E", // Teal
      "#2563EB", // Blue
      "#B45309", // Amber
      "#DC2626", // Red
      "#BE185D", // Pink
      "#15803D", // Green
      "#C2410C", // Orange
      "#4338CA", // Indigo
      "#0E7490", // Cyan
    ];

    setEmployeeColors(
      employees.map((employee, index) => ({
        name: employee.name,
        color: colors[index % colors.length],
      })),
    );
  }, [employees]);
  const getUnavailableEmployees = async () => {
    let firstDate = new Date();
    let lastDate = new Date();
    switch (view) {
      case "day":
        firstDate = new Date(selectedDate);
        lastDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate() + 1,
        );
        break;
      case "week":
        const d = new Date(selectedDate);
        const day = d.getDay();
        firstDate = new Date(d);
        firstDate.setDate(d.getDate() - day);

        lastDate = new Date(firstDate);
        lastDate.setDate(firstDate.getDate() + 6);
        break;
      case "month":
        firstDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          1,
        );
        lastDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth() + 1,
          0,
        );
        break;
    }
    try {
      const unavailable = (
        await Promise.all(
          selectedEmployees.map((employee) =>
            getUnavailabilityByBarber(
              user.barberShop,
              employee,
              firstDate.toISOString().split("T")[0],
              lastDate.toISOString().split("T")[0],
            ),
          ),
        )
      ).flat();
      const updatedUnavailable = unavailable.map((item) => {
        const employee = employees.find(
          (employee) =>
            employee.id.toLowerCase() === item.barberId.toLowerCase(),
        );
        return {
          ...item,
          barber: employee?.name || "",
          startTime: item.startTime == null ? "08:00:00" : item.startTime,
          endTime: item.endTime == null ? "20:00:00" : item.endTime,
        };
      });
      setUnavailabelEmployees(updatedUnavailable);
    } catch (err) {
      console.error("Failed to fetch dashboard data:", err);
    }
  };
  const getAppointments = async () => {
    let firstDate = new Date();
    let lastDate = new Date();
    switch (view) {
      case "day":
        firstDate = new Date(selectedDate);
        lastDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate() + 1,
        );
        break;
      case "week":
        const d = new Date(selectedDate);
        const day = d.getDay();
        firstDate = new Date(d);
        firstDate.setDate(d.getDate() - day);

        lastDate = new Date(firstDate);
        lastDate.setDate(firstDate.getDate() + 6);
        break;
      case "month":
        firstDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          1,
        );
        lastDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth() + 1,
          0,
        );
        break;
    }
    try {
      var response = await getappointmentsPerDates(
        user.barberShop,
        firstDate,
        lastDate,
      );
      setAppointments(response);
    } catch (err) {
      console.error("Failed to fetch dashboard data:", err);
    }
  };
  const getEmployees = async () => {
    try {
      var response = await getbarbers(user.barberShop);
      setEmployees(response);
      setSelectedEmployees([response[0].id]);
    } catch (err) {
      console.error("Failed to fetch dashboard data:", err);
    }
  };
  const getWeekRange = (date) => {
    const d = new Date(date);
    const day = d.getDay();

    const firstDate = new Date(d);
    firstDate.setDate(d.getDate() - day);

    const lastDate = new Date(firstDate);
    lastDate.setDate(firstDate.getDate() + 6);

    return (
      lastDate.toLocaleString("default", {
        month: "short",
      }) +
      " " +
      firstDate.getDate() +
      "-" +
      lastDate.getDate() +
      ", " +
      lastDate.getFullYear()
    );
  };

  const displayDate = () => {
    switch (view) {
      case "day":
        return selectedDate.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        });

      case "week":
        return getWeekRange(selectedDate);

      case "month":
        return selectedDate.toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
        });

      default:
        return "";
    }
  };

  const changeDate = (amount) => {
    const newDate = new Date(selectedDate);

    switch (view) {
      case "day":
        newDate.setDate(newDate.getDate() + amount);
        break;

      case "week":
        newDate.setDate(newDate.getDate() + amount * 7);
        break;

      case "month":
        newDate.setMonth(newDate.getMonth() + amount);
        break;
    }

    setSelectedDate(newDate);
  };

  const goToday = () => {
    setSelectedDate(new Date());
  };
  const toggleEmployeeSelection = (id) => {
    //look to the selectedEmployees if it is exist remove it if not add it
    setSelectedEmployees((prevEmployees) => {
      if (prevEmployees.includes(id)) {
        return prevEmployees.filter((employeeId) => employeeId !== id);
      }

      return [...prevEmployees, id];
    });
  };
  const closeModalShortcut = () => {
    setSelectedDateSlot();
    setshowModal(false);
  };
  const showModalShortcut = (date, time) => {
    if (selectedEmployees.length == 1) {
      const newDate = new Date(date);
      const today = new Date();
      newDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (date >= today) {
        const options = {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        };

        // Output: Monday, August 24, 2026
        setSelectedDateSlot({
          date: newDate.toLocaleDateString("en-US", options),
          time: time,
        });
        setshowModal(true);
      }
    }
  };
  const handleAddSelection = (type) => {
    if (type === "unavailability") {
      setUnavailability({
        date: selectedDateSlot.date,
        startTime: selectedDateSlot.time,
        endTime: selectedDateSlot.time,
      });
    }
    setActiveModal(type);
    setshowModal(true);
  };
  const onCloseModalClick = () => {
    setshowModal(false);
    setActiveModal(null);
  };
  const onAddUnavailable = async (data) => {
    if (selectedEmployees.length == 1) {
      const dt = new Date(`${data.selectedToDate}Z`);
      const apiDate = dt.toISOString().split("T")[0];
      const unavailability = {
        ShopId: user.barberShop,
        BarberId: selectedEmployees[0],
        FromDate: apiDate, // e.g. "Monday" or number (0-6)
        ToDate: apiDate, // e.g. "Monday" or number (0-6)
        StartTime: data.startTime, // "09:00:00"
        EndTime: data.endTime, // "17:00:00"
        Reason: data.reason,
      };

      var result = await createUnavailability(user.barberShop, unavailability);
      if (result) {
        refresh();
      }
    } else {
      window.alert("You should select only one stuff");
    }
  };
  const onAddAppointment = async (data, overlaps) => {
    try {
      // Example list of services with dynamic GUID keys
      const selectedServiceList = data.selectedServices.map((s) => ({
        id: s.serviceId,
        quantity: s.quantity,
      }));

      // Convert to dictionary-style object expected by .NET
      const servicesDict = {};
      selectedServiceList.forEach((s) => {
        servicesDict[s.id] = s.quantity;
      });
      const dt = new Date(`${data.date}Z`);
      const apiDate = dt.toISOString().split("T")[0];

      const response = overlaps
        ? await AddAnyWayAppointment(
            user.barberShop,
            selectedEmployees[0],
            data.customer,
            servicesDict,
            apiDate,
            data.startTime,
            0,
          )
        : await AddAppointment(
            user.barberShop,
            selectedEmployees[0],
            data.customer,
            servicesDict,
            apiDate,
            data.startTime,
            0,
          );

      if (response.data.isSuccess) {
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
      } else {
        setMessage({
          text: response?.data.errors?.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
    refresh();
  };
  return {
    view,
    setView,

    selectedDate,
    setSelectedDate,
    getAppointments,
    displayedAppointments,
    employeeColors,
    displayDate,
    employees,
    selectedEmployees,
    toggleEmployeeSelection,
    unavailableEmployees,
    next: () => changeDate(1),
    previous: () => changeDate(-1),
    showModalShortcut,
    showModal,
    selectedDateSlot,
    closeModalShortcut,
    handleAddSelection,
    goToday,
    activeModal,
    unavailability,
    onCloseModalClick,
    onAddUnavailable,
    onAddAppointment,
    message,
    showMessage,
    setShowMessage,
  };
};

export default useCalendar;
